<p class="text-muted-color font-light text-sm">{{ label() }}</p>
@let val = value();
<!-- items-start, not items-center: a value that wraps to several lines would otherwise drag the
     copy button down to its vertical middle. min-w-0 lets the value shrink inside the flex row so
     long unbroken strings (URLs in sync errors, ids) wrap instead of widening the grid column. -->
<div class="flex items-start gap-2">
  @if (val) {
    @if (tagFunction(); as func) {
      <p-tag [severity]="func(val)">{{ val }}</p-tag>
    } @else {
      <p class="min-w-0 break-words">{{ val }}</p>
    }
  } @else {
    <p>-</p>
  }
  @if (copy() && val) {
    <homey-copy-button [value]="val" [label]="label()"/>
  }
</div>
